// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getProcedencias as listProcedenciasAPI,
    getProcedencia as getProcedenciaAPI,
    addProcedencia as addProcedenciaAPI,
    updateProcedencia as updateProcedenciaAPI,
    deleteProcedencia as deleteProcedenciaAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { procedenciasApiResponseError, procedenciasApiResponseSuccess } from './actions';
import { ProcedenciasActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getProcedencia({ payload: { id } }) {
    try {
        const response = yield call(getProcedenciaAPI, id );
        const procedenciaItem = response.data.data;
        yield put(procedenciasApiResponseSuccess(ProcedenciasActionTypes.GET_PROCEDENCIA, procedenciaItem));
    } catch (error) {
        yield put(procedenciasApiResponseError(ProcedenciasActionTypes.GET_PROCEDENCIA, error));
    }
}

function* addProcedencia({payload:procedencia}){
    try{
        const response = yield call(addProcedenciaAPI,{...procedencia})
        const procedenciaItem = response.data.data
        yield put(procedenciasApiResponseSuccess(ProcedenciasActionTypes.ADD_PROCEDENCIA,procedenciaItem))
    } catch(error){
        yield put(procedenciasApiResponseError(ProcedenciasActionTypes.ADD_PROCEDENCIA,error))
    }
}

function* updateProcedencia({payload:procedencia}){
    try{
        const response = yield call(updateProcedenciaAPI,{...procedencia})
        const procedenciaItem = response.data.data
        yield put(procedenciasApiResponseSuccess(ProcedenciasActionTypes.UPDATE_PROCEDENCIA,procedenciaItem))
    }catch(error){
        yield put(procedenciasApiResponseError(ProcedenciasActionTypes.UPDATE_PROCEDENCIA,error))
    }
}
function* deleteProcedencia({payload:{id}}){
    try{
        const response = yield call(deleteProcedenciaAPI,id)
        const procedenciaItem = response.data.id
        yield put(procedenciasApiResponseSuccess(ProcedenciasActionTypes.DELETE_PROCEDENCIA,procedenciaItem))
    }catch(error){
        yield put(procedenciasApiResponseError(ProcedenciasActionTypes.DELETE_PROCEDENCIA,error))
    }
}

/**
 * List contactos
 */
function* listProcedencias({payload:params}) {
    try {
        const response = yield call(listProcedenciasAPI, { ...params });
        const listaProcedencias = response.data.data;
        yield put(procedenciasApiResponseSuccess(ProcedenciasActionTypes.LIST_PROCEDENCIAS, listaProcedencias));
    } catch (error) {
        yield put(procedenciasApiResponseError(ProcedenciasActionTypes.LIST_PROCEDENCIAS, error));
    }
}


export function* watchGetProcedencia(): any {
    yield takeEvery(ProcedenciasActionTypes.GET_PROCEDENCIA, getProcedencia);
}

export function* watchListProcedencias(): any {
    yield takeEvery(ProcedenciasActionTypes.LIST_PROCEDENCIAS, listProcedencias);
}

export function* watchAddProcedencia():any{
    yield takeEvery(ProcedenciasActionTypes.ADD_PROCEDENCIA,addProcedencia)
}
export function* watchUpdateProcedencia():any{
    yield takeEvery(ProcedenciasActionTypes.UPDATE_PROCEDENCIA,updateProcedencia)
}
export function* watchDeleteProcedencia():any{
    yield takeEvery(ProcedenciasActionTypes.DELETE_PROCEDENCIA,deleteProcedencia)
}


function* procedenciasSaga(): any {
    yield all([
        fork(watchGetProcedencia),
        fork(watchListProcedencias),
        fork(watchAddProcedencia),
        fork(watchUpdateProcedencia),
        fork(watchDeleteProcedencia),
    ]);
}

export default procedenciasSaga;
